import { createSelector } from '@reduxjs/toolkit';
import { themeSlice } from './themeSlice';
import { type RootStateWithThemeSlice } from './themeSlice.types';

export const getThemeState = (rootState: RootStateWithThemeSlice) => rootState[themeSlice.name];
export const getBgColor = createSelector(getThemeState, themeState => themeState.bgColor);
